export enum AddressType {
  Customer = 0,
  Store = 1,
}
